import React, { useState } from 'react';
import { Modal, Tooltip } from 'antd';
import { Button, FormatText, FormSubmitButton, FormTextArea, MasterDetailForm, Widget } from '@digital/ui';
import { hasPermission } from '@app/helpers/permissions';
import './modal.css';
import { confirmarIntegracao } from '@app/api/ContabilidadeGeral';

export interface propsButtonConfirmarIntegracao {
    arquivoAutorizacaoId: string;
    updatePage: any;
}

const ButtonConfirmarIntegracao = (props: propsButtonConfirmarIntegracao) => {
    const { arquivoAutorizacaoId, updatePage } = props;
    const [exibirModal, setExibirModal] = useState(false);

    const handleSubmit = (values: any) => {
        confirmarIntegracao(values).then(data => {
            if (data) {
                setExibirModal(false);
                updatePage();
            }
        });
    };

    return (
        <>
            <Tooltip title="Confirmar Integração">
                <Button
                    onClick={() => {
                        handleSubmit({ arquivoAutorizacaoId });
                    }}
                    name="btnConfirmarIntegracao"
                    confirm={'Confirmar Integração?'}
                    okText={"Confirmar Integração"}
                    icon="messaging-send_file"
                />
            </Tooltip>
        </>
    );
};
export default ButtonConfirmarIntegracao; 